import * as actions from './actions';

export const putSubaccountUserInStore = (payload) => (dispatch) => {
  dispatch(actions.putUserInStore({
    ...payload,
    user_type: 'subaccount',
  }));
};

export const fetchOpenSauceUser = (payload) => (dispatch) => (
  // RESTo returns 403 response users's is_public flag is false
  // General axios middleware will cause an error page to show, no need for custom logic
  dispatch(actions.getRestoUser(payload))
    .then(({ data }) => (
      dispatch(actions.putUserInStore({
        ...data,
        // NOTE: Normalize resto user data with user-service user data
        user_id: data.id,
      }))
    ))
);

export const initialize = (payload) => (dispatch) => {
  dispatch(actions.putUserInStore(payload.user));
  return dispatch(actions.initialize());
};
